import styled, { keyframes, css } from 'styled-components';
import { LAYERS } from '../../common/sizes';
import { HEADER_HEIGHT } from 'common/global';

const opacityAppear = keyframes`
    from { background-color: transparent; }
    to { background-color: rgba(1,1,1,0.2); }
`

const appear = props =>
    css`
    ${opacityAppear} 0.35s;
`

const opacityDisapear = keyframes`
    from { background-color: rgba(1,1,1,0.2); }
    to { background-color: transparent; }
`

const disappear = props =>
    css`
    ${opacityDisapear} 0.450s 0.20s;
`

interface ModalContainerProps {
    shouldShow: boolean;
}
export const ModalContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: ${LAYERS.LAYER_5};
    background-color: rgba(1,1,1,0.2);
    width: 100%;
    height: calc(100% - ${HEADER_HEIGHT});
    left: 0px;
    bottom: 0px;
    animation: ${(props: ModalContainerProps) => props.shouldShow ? appear : disappear};
    animation-fill-mode: forwards;
`
;